<template>
<div>
  <v-tabs
    v-model="tab"
    v-bind="$attrs"
    @change="$emit('tabChanged', tab)"
    color="grey lighten-2"
    show-arrows
  >
    <v-tab
      v-for="header in tabsHeader"
      :key="header"
      ripple
    >
      {{ header }}
    </v-tab>
  </v-tabs>
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'SharedTabs',
  props: {
    currentTab: {
      type: Number,
    },
    tabsHeader: {
      type: Array,
      required: true
    },
  },
  data: () => ({
    tab: 0
  }),
  watch: {
    currentTab(value) {
      this.tab = value;
    }
  }
}
</script>